export const CompanyInfo = ({ formData, onChange, onNext }) => {
    return (
        <div className="w-full">
            <h2 className="text-2xl font-bold mb-6">Informations de votre entreprise</h2>
            <p className="mb-6 text-gray-600">Débutant ou non, vous bénéficiez chez nous d'un accompagnement sur mesure.</p>

            <div className="mb-4">
                <label className="block text-gray-700 mb-2">Nom de l'entreprise</label>
                <input
                    type="text"
                    placeholder="Ex: Payor"
                    value={formData.companyName}
                    onChange={(e) => onChange('companyName', e.target.value)}
                    className="input input-bordered w-full px-4 py-2 rounded"
                    required
                />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                    <label className="block text-gray-700 mb-2">Forme juridique de l'entreprise</label>
                    <input
                        type="text"
                        placeholder="Ex: SARL"
                        value={formData.legalForm}
                        onChange={(e) => onChange('legalForm', e.target.value)}
                        className="input input-bordered w-full px-4 py-2 rounded"
                    />
                </div>
                <div>
                    <label className="block text-gray-700 mb-2">Numéro d'identification de l'entreprise</label>
                    <input
                        type="text"
                        placeholder="NINEA"
                        value={formData.companyId}
                        onChange={(e) => onChange('companyId', e.target.value)}
                        className="input input-bordered w-full px-4 py-2 rounded"
                    />
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                    <label className="block text-gray-700 mb-2">Adresse Physique de votre entreprise</label>
                    <input
                        type="text"
                        placeholder="adresse"
                        value={formData.companyAddress}
                        onChange={(e) => onChange('companyAddress', e.target.value)}
                        className="input input-bordered w-full px-4 py-2 rounded"
                        required
                    />
                </div>
                <div>
                    <label className="block text-gray-700 mb-2">Ville</label>
                    <input
                        type="text"
                        placeholder="Dakar"
                        value={formData.city}
                        onChange={(e) => onChange('city', e.target.value)}
                        className="input input-bordered w-full px-4 py-2 rounded"
                    />
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                <div>
                    <label className="block text-gray-700 mb-2">Secteur d'activité</label>
                    <select
                        value={formData.sector}
                        onChange={(e) => onChange('sector', e.target.value)}
                        className="input input-bordered w-full px-4 py-2 rounded"
                    >
                        <option value="">Sélectionnez un secteur</option>
                        <option value="Santé">Santé</option>
                        <option value="Education">Education</option>
                        <option value="Finance">Finance</option>
                        <option value="Commerce">Commerce</option>
                        <option value="Technologie">Technologie</option>
                    </select>
                </div>
                <div>
                    <label className="block text-gray-700 mb-2">Taux horaire</label>
                    <select
                        value={formData.hourlyRate}
                        onChange={(e) => onChange('hourlyRate', e.target.value)}
                        className="input input-bordered w-full px-4 py-2 rounded"
                    >
                        <option value="">Sélectionnez un taux</option>
                        <option value="40">40</option>
                        <option value="35">42</option>
                    </select>
                </div>
            </div>

            <div className="mb-6">
                <label className="flex items-center">
                    <input
                        type="checkbox"
                        checked={formData.termsAccepted}
                        onChange={(e) => onChange('termsAccepted', e.target.checked)}
                        className="mr-2"
                    />
                    <span>Je confirme que ces informations sont exactes et à jour.</span>
                </label>
            </div>

            <div className="border rounded-lg p-6 mb-6 bg-gray-50">
                <h3 className="font-semibold mb-2">Vous avez déjà un compte ?</h3>
                <p className="text-gray-600 mb-2">Si votre entreprise utilise déjà YROS et vous souhaitez accéder à votre espace, c'est par ici.</p>
                <a href="/" className="text-[--color-primary] font-medium">Se connecter</a>
            </div>
        </div>
    );
};